import * as React from 'react';
import { Button, Typography } from 'antd';
import { H1, H2 } from './ui/Typography';

const { Title } = Typography;

interface FCProps {
  title?: React.ReactNode;
  button?: React.ReactElement;
}

const CardContainer: React.FC<React.PropsWithChildren<FCProps>> = ({
  title,
  button,
  children
}) => {
  return (
    <div>
      {title && <div className="flex sm:items-center sm:justify-center">
        <H1 style={{ fontWeight: 400}} className="sm:text-center font">{title}</H1>
        {button}
      </div>}
      <div>{children}</div>
    </div>
  );
};

export default CardContainer;
